import styled from 'foundations-theming/utils';
import LoadingMerchCardCTAs from '../../components/merch-card/LoadingMerchCardCTAs';
import { LoadableWrapper } from '../common/LoadableWrapper';
import { useRecommendedSalesHubProCTAsProps } from './useRecommendedSalesHubProCTAsProps';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecommendedCTAs = styled.div.withConfig({
  displayName: "RecommendedSalesHubProCTAsContainer__StyledRecommendedCTAs",
  componentId: "sc-1jnq83l-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    button: {
      background: 'none',
      borderStyle: 'none',
      color: theme.color['text-interactive-default'],
      paddingBlock: theme.space[100],
      paddingInlineStart: theme.space[0],
      paddingInlineEnd: theme.space[100]
    },
    '&:not(:first-child)': {
      marginBottom: theme.space[100],
      paddingLeft: theme.space[200]
    },
    '&:not(:last-child)': {
      borderRight: `${theme.borderWidth[100]} solid ${theme.color['border-core-default']}`,
      borderRadius: theme.borderRadius[0]
    },
    '&:hover': {
      background: 'none',
      color: theme.color['text-interactive-default']
    }
  };
});
const RecommendedSalesHubProCTAsContainer = props => {
  const commonAuthProps = useRecommendedSalesHubProCTAsProps(Object.assign({}, props));
  return /*#__PURE__*/_jsx(StyledRecommendedCTAs, {
    children: /*#__PURE__*/_jsx(LoadableWrapper, {
      loader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/auth-cta-motions/AuthedCTAs`),
      componentProps: Object.assign({}, props, commonAuthProps),
      LoadingComponent: LoadingMerchCardCTAs
    })
  });
};
export default RecommendedSalesHubProCTAsContainer;